import styled from '@emotion/styled/macro';
import { Variables } from '../../base';
import Icon from '@mdi/react';

export const TruncatedValue = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
`;

export const CrossIcon = styled(Icon)`
    fill: ${Variables.Colors.warning};
    vertical-align: bottom;
`;

export const CheckIcon = styled(Icon)`
    fill: ${Variables.Colors.successful};
    vertical-align: bottom;
`;

export const BoxHeading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${Variables.Colors.n100};
    font-weight: 500;
    padding: 8px 0;
`;
